import { useTheme } from "@/contexts/ThemeContext"
import { Toaster as Sonner, toast } from "sonner"

type ToasterProps = React.ComponentProps<typeof Sonner>

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme } = useTheme()

  return (
    <Sonner
      theme={theme === 'system' ? undefined : theme}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-white group-[.toaster]:text-sauna-navy group-[.toaster]:border-2 group-[.toaster]:border-sauna-orange/20 group-[.toaster]:shadow-lg group-[.toaster]:rounded-xl",
          description: "group-[.toast]:text-sauna-navy/80",
          actionButton:
            "group-[.toast]:bg-sauna-orange group-[.toast]:text-white",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
          success: "group-[.toast]:border-sauna-green/40 group-[.toast]:bg-sauna-green/10",
          error: "group-[.toast]:border-sauna-red/40 group-[.toast]:bg-sauna-red/10",
          info: "group-[.toast]:border-sauna-blue/40 group-[.toast]:bg-sauna-blue/10",
          warning: "group-[.toast]:border-yellow-500/40 group-[.toast]:bg-yellow-500/10",
          closeButton: "group-[.toast]:bg-transparent group-[.toast]:border-none",
          title: "group-[.toast]:font-semibold group-[.toast]:text-lg",
          loader: "group-[.toast]:text-sauna-orange",
        },
        duration: 4000,
        className: "p-4 rounded-xl shadow-md border-2 flex items-start gap-3"
      }}
      {...props}
    />
  )
}

export { Toaster, toast }
